<template>
    <section class="section-class-personal-page">
        <div class="ss-breadcrumb">
            <div class="container-hts">
                <ul class="margin-0 p-0">
                    <li><router-link to="/lop-hoc">Lớp học</router-link></li>
                    <li><router-link to="/lop-hoc">Trang cá nhân</router-link></li>
                    <li><router-link :to="{path: '/trang-ca-nhan-giao-vien', query: { id: classSchoolId, nameClass: nameClass }}">{{ nameClass }}</router-link></li>
                    <li><router-link to="">{{ nameLessonPlan }}</router-link></li>
                </ul>
            </div>
        </div>
        <div class="container">
            <div class="pt-4">
                <h2 class="font-weight-bold">{{ nameLessonPlan }}</h2>
            </div>
            <b-tabs class="pre-class-school-list__filter__tabs">
                <b-tab title="Thống kê" @click="handleChangeTab(tabStatistic)" :active="tabActive == tabStatistic">
                    <TabStatisticLessonPlan v-if="tabActive == tabStatistic" 
                        :lessonClassSchoolId="lessonClassSchoolId"
                        :listGroupId="listGroupId"
                        :classSchoolId="classSchoolId"
                    />
                </b-tab>
                <b-tab title="Nội dung" @click="handleChangeTab(tabContent)" :active="tabActive == tabContent">
                    <TabContentLessonPlan v-if="tabActive == tabContent" 
                        :lessonClassSchoolId="lessonClassSchoolId"
                        :listGroupId="listGroupId"
                        :classSchoolId="classSchoolId"
                    />
                </b-tab>
            </b-tabs>
        </div>
    </section>
</template>
<script>
import TabStatisticLessonPlan from './_components/TabStatisticLessonPlan.vue'
import TabContentLessonPlan from './_components/TabContentLessonPlan.vue'
export default{
    components:{
        TabStatisticLessonPlan,
        TabContentLessonPlan
    },
    data(){
        return{
            nameClass: '',
            nameLessonPlan: '',
            tabActive:1,
            tabStatistic:1,
            tabContent:2,
            lessonClassSchoolId: 0,
            listGroupId: 0,
            classSchoolId: 0,
        }
    },
    mounted(){
        this.lessonClassSchoolId = this.$router.history.current.query.id * 1
        this.classSchoolId = this.$router.history.current.query.classSchoolId * 1
        this.listGroupId = this.$router.history.current.query.listGroupId * 1
        this.nameClass = this.$router.history.current.query.nameClass
        this.nameLessonPlan = this.$router.history.current.query.namePageDetail
    },
    methods:{
        handleChangeTab(tab){
            this.tabActive = tab
        }
    }
}
</script>
<style lang="scss" scoped>
    .pre-class-school-list__filter__tabs ul.nav-tabs li.nav-item {
        padding: 0 3rem;
    }
</style>